import styled from "styled-components";

/**
 * Shared table action icon button for the geo calc / sim job tables.
 * Matches the org-settings convention (see OrganizationForecastNodeActions):
 * grey by default, and on hover it highlights to the primary green for
 * constructive actions (calculate, download), red for destructive ones
 * (delete). "neutral" is for non-highlighting actions such as cancel.
 */
export const ActionIconButton = styled.button<{
  $variant?: "primary" | "danger" | "neutral";
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 4px;
  margin: 1px;
  background: transparent;
  cursor: pointer;
  color: #a2aaad;
  transition: color 0.15s ease;

  &:hover {
    color: ${(props) =>
      props.$variant === "danger"
        ? "var(--color-danger)"
        : props.$variant === "neutral"
        ? "#4b5563"
        : "var(--color-primary)"};
  }

  &[disabled] {
    cursor: not-allowed;
    color: #d9d9d9;
  }
  &[disabled]:hover {
    color: #d9d9d9;
  }
`;
